var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgMaximize = function SvgMaximize(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Maximize' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.9998 36.5764 1.9998 24.9994 -0.0002 24.9994 -0.0002 40.0004 15.0008 40.0004 15.0008 38.0004 2.9178 38.0004 16.3348 24.7024 15.0458 23.2834"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.0002 0.0004 25.0002 2.0004 36.0902 2.0004 22.7972 15.2884 24.4592 16.7004 38.0002 3.4054 38.0002 14.9994 39.9992 14.9994 39.9992 0.0004"
  }));
};
SvgMaximize = pure(SvgMaximize);
SvgMaximize.displayName = 'SvgMaximize';
export default SvgMaximize;